import { useEffect, useState } from 'react';
import { Box, Grid, LinearProgress, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { LayoutBase } from '../../layouts';
import { ToolsDashbord } from '../../components/custom';
import { CustomAlert, VCard } from '../../components/shared';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';
import { useAuthContext } from '../../context';

export const Dashboard = () => {
  
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [rows, setRows] = useState<IDamsList[]>([]);
  const navigate = useNavigate();
  const { userData } = useAuthContext();  

  const [ isLoadin, setIsLoadin ] = useState(true);
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    fetchData();    
  }, []);

  const fetchData = () => {
    setIsLoadin(true);
    if(userData.id_empresa){
      DamsServices.get(userData.id_empresa)
        .then((response) => {    
          if(response instanceof Error){
            setAlertInfo({open: true, message: `Erro ao buscar dados! error: ${response.message}` , severity: 'error'});
          }else{
            if(response.length > 0){
              const dams = response.filter(index => index.status === true);
              setRows(dams);
              setIsLoadin(false);
            }else{
              setIsLoadin(false);
              setAlertInfo({open: true, message: 'Não há nenhuma barragem cadastrada' , severity: 'info'});
            }
          }
        });
    }else{
      setAlertInfo({open: true, message: 'Sem empresa vinculada a você' , severity: 'error'});
    }
  };

  return (
    <LayoutBase
      title='Dashboard'
      tollBar={(
        <ToolsDashbord />
      )}
    >
      {isLoadin? (
        <LinearProgress/>
      ) : (
        <Box margin={0} display={'flex'} flexDirection={'column'}>
          <Grid container direction={'column'} padding={2} spacing={2}>
            <Grid container direction={'row'} spacing={4} padding={1}>
              {rows.filter(dam => dam.status === true).map((dam, index) => (
                <Grid key={index} item xs={smDown ? 12 : 4}>
                  <VCard
                    title={dam.nome}
                    altText={dam.nome}
                    imageUrl={dam.imagem}
                    subtitle={dam.update_date}
                    button1Label='Detalhes'
                    onButton1Click={() => navigate(`/information_dam/${dam.uuid}`)}
                    button2Label='KPI'
                    onButton2Click={() => navigate(`/information_dam/${dam.uuid}/kpi`)}
                    company={false}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          {alertInfo.open &&
                    <CustomAlert
                        message={alertInfo.message}
                        severity={alertInfo.severity}
                    />
          }
        </Box>
      )}
    </LayoutBase>
  );
};
